import styled from '@emotion/styled';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Search as IconSearch } from 'lucide-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import ENV from '../../../env.json';
import { NAV } from '../../sitemap';

const styles = (theme: any) => ({
  categoryHeader: {
    paddingTop: 16,
    paddingBottom: 16
  },
  categoryHeaderPrimary: {
    color: theme.palette.common.white
  },
  list: {
    flex: 1
  },
  item: {
    paddingTop: 4,
    paddingBottom: 4,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  itemCategory: {
    backgroundColor: '#232f3e',
    boxShadow: '0 -1px 0 #404854 inset',
    paddingTop: 16,
    paddingBottom: 16
  },
  firebase: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.common.white
  },
  itemActionable: {
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)'
    }
  },
  disabled: {
    opacity: 0.5,
    cursor: 'default'
  },
  itemActiveItem: {
    color: '#6399f4'
  },
  active: {
    color: '#6399f4',
    '& $itemActionable': {
      color: '#6399f4'
    },
    '& $itemPrimary': {
      color: '#6399f4'
    }
  },
  itemPrimary: {
    color: 'inherit',
    fontSize: theme.typography.fontSize
  }
});

const EnvFooter = styled('div')<{ safe: boolean }>`
  background-color: ${(p) => (p.safe ? '#232f3e' : 'red')};
  font-size: ${(p) => p.theme.custom.fontSize.l}px;
  color: ${(p) => (p.safe ? 'rgba(255, 255, 255, 0.7)' : 'white')};
  box-shadow: 0 1px 0 #404854 inset;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
`;

function Navigator(props: any) {
  const { classes, ...other } = props;

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding className={classes.list}>
        <ListItem
          className={classNames(
            classes.firebase,
            classes.item,
            classes.itemCategory
          )}
        >
          &nbsp; Admin App
        </ListItem>
        {false && (
          <ListItem className={classNames(classes.item, classes.itemCategory)}>
            <ListItemIcon>
              <IconSearch />
            </ListItemIcon>
            <ListItemText
              classes={{
                primary: classes.itemPrimary
              }}
            >
              Search your products
            </ListItemText>
          </ListItem>
        )}
        {NAV.map(({ id, children }) => (
          <React.Fragment key={id}>
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary
                }}
              >
                {id}
              </ListItemText>
            </ListItem>
            {children.map(({ id: childId, icon, route, disabled }) =>
              disabled ? (
                <ListItem
                  button
                  dense
                  key={childId}
                  className={classNames(classes.item, classes.disabled)}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: classes.itemPrimary
                    }}
                  >
                    {childId}
                  </ListItemText>
                </ListItem>
              ) : (
                <NavLink
                  to={route}
                  key={childId}
                  activeClassName={classes.active}
                >
                  <ListItem
                    button
                    dense
                    key={childId}
                    className={classNames(classes.item, classes.itemActionable)}
                  >
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: classes.itemPrimary
                      }}
                    >
                      {childId}
                    </ListItemText>
                  </ListItem>
                </NavLink>
              )
            )}
          </React.Fragment>
        ))}
      </List>
      <EnvFooter safe={ENV.env.safe}>{ENV.env.name}</EnvFooter>
    </Drawer>
  );
}

export default withStyles(styles)(Navigator);
